import React, { Component, useState, useEffect, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    position: 'relative',
    backgroundColor: '#efefef',
    marginLeft: -(theme.spacing(1.5)),
    marginRight: -(theme.spacing(1.5)),    
  },
  content: {
    padding: theme.spacing(1.5)
  },
  contentDivider: {
    backgroundColor: '#fff',
    width: theme.spacing(.5), 
  },
  contentLabel: {
    color: '#777'
  },
  contentValue: {
    fontWeight: 500
  }  
})


const InfoSectionContent = ({ theme, classes, item }) => {

  return (
    <Box display='flex' flexDirection='column'
      flexGrow={1}
      className={classes.content}
      >
      <Box>
        <Typography variant='body2' className={classes.contentLabel}>
          { item.label }
        </Typography>
      </Box>
      <Box>
        <Typography variant='body1' className={classes.contentValue}>
          { item.value }
        </Typography>
      </Box>
    </Box>
  )
}

const InfoSection = ({ theme, classes, gutterBottom, items, color='#efefef', itemComponent=InfoSectionContent }) => {
  
  const renderItem = (item, index) => {
    return React.createElement(itemComponent, {
      theme,
      classes,
      item,
      index
    })
  }
  
  const divider = (
    <Box flexShrink={1} className={classes.contentDivider} />
  )
  
  return (
    <Box display='flex' className={classes.root}
      mb={ gutterBottom ? 4 : 0 }    
      alignItems='stretch'
      style={{
        backgroundColor: color
      }}
      >
      { items.map(renderItem).reduce((p, n) => p ?
          [...p, divider, n] : [n], null)
      }
    </Box>  
  )
}

export default withStyles(styles, { withTheme: true })(
  InfoSection
)

